export const LatentToolMode = Object.freeze({
    DOT: 'DOT',
    DEL: 'DEL',
    HAND: 'HAND'
})